import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Sidebar from './Common/Sliderbar';
import Header from './Common/Header';
import Dashboard from './Components/pages/Dashboard';
import Login from './Components/layout/Login';
import Industries from './Components/pages/Industries';
import Skills from './Components/pages/Skills';
import Gigs from './Components/pages/Gigs';
import Companies from './Components/pages/Companies';
import PlatformFees from './Components/pages/PlatformFees';
import PlatformPerformance from './Components/pages/PlatformPerformance';
import PlatformEarnings from './Components/pages/PlatformEarnings';
import Document from './Components/pages/Document';
import Countries from './Components/pages/location/Countries';
import User from './Components/pages/user/User';
import DisputeList from './Components/pages/Dispute/DisputeList';
import DisputeDetails from './Components/pages/Dispute/DisputeDetails';


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const authUser = sessionStorage.getItem('AuthUser');
    return !!authUser;
  });

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const Layout = ({ children }) => (
    <div className="layout-container" style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
      <div className="main-content" style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        overflow: 'hidden',
        marginLeft: sidebarCollapsed ? '60px' : '14rem', // Adjust based on your sidebar width
        transition: 'margin-left 0.5s ease'
      }}>
        <Header
          onLogout={handleLogout}
          onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
        />
        <main style={{
          flex: 1,
          padding: '1rem',
          overflow: 'auto',
          backgroundColor: '#f8f9fa',
        }}>
          {children}
        </main>
      </div>
    </div>
  );

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem('AuthUser');
    setIsAuthenticated(false);
  };

  useEffect(() => {
    const checkAuth = () => {
      const authUser = sessionStorage.getItem('AuthUser');
      setIsAuthenticated(!!authUser);
    };

    window.addEventListener('storage', checkAuth);
    return () => window.removeEventListener('storage', checkAuth);
  }, []);

  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboards" replace />
            ) : (
              <Login onLogin={handleLogin} />
            )
          }
        />

        <Route
          path="/dashboards"
          element={
            isAuthenticated ? (
              <Layout>
                <Dashboard />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route path="/industries" element={isAuthenticated ? (<Layout><Industries /></Layout>) : (<Navigate to="/login" replace />)} />
        <Route path="/skills" element={isAuthenticated ? (<Layout><Skills /></Layout>) : (<Navigate to="/login" replace />)} />
        <Route path="/gigs" element={isAuthenticated ? (<Layout><Gigs /></Layout>) : (<Navigate to="/login" replace />)} />
        <Route path="/companies" element={isAuthenticated ? (<Layout><Companies /></Layout>) : (<Navigate to="/login" replace />)} />
        <Route path="/platformfee" element={isAuthenticated ? (<Layout><PlatformFees /></Layout>) : (<Navigate to="/login" replace />)} />
        <Route path="/platform-performance" element={isAuthenticated ? (<Layout><PlatformPerformance /></Layout>) : (<Navigate to="/login" replace />)} />
        <Route path="/platform-earnings" element={isAuthenticated ? (<Layout><PlatformEarnings /></Layout>) : (<Navigate to="/login" replace />)} />
        <Route path="/documents" element={isAuthenticated ? (<Layout><Document /></Layout>) : (<Navigate to="/login" replace />)} />
        <Route path="/countries" element={isAuthenticated ? (<Layout><Countries /></Layout>) : (<Navigate to="/login" replace />)} />
        <Route path="/users" element={isAuthenticated ? (<Layout><User /></Layout>) : (<Navigate to="/login" replace />)} />
        <Route path="/disputes" element={isAuthenticated ? (<Layout><DisputeList /></Layout>) : (<Navigate to="/login" replace />)} />
        <Route path="/disputes/:id" element={isAuthenticated ? (<Layout><DisputeDetails /></Layout>) : (<Navigate to="/login" replace />)} />


        <Route path="*" element={<Navigate to="/dashboards" replace />} />
      </Routes>
    </Router>
  );
}

export default App;